// extracted by mini-css-extract-plugin
export default {"provisionBody":"ProvisionCard_provisionBody__f1e4o","tables":"ProvisionCard_tables__W5rvH"};